import { Minus, Plus } from "lucide-react";

export default function ScoreStepper({ value, onChange, disabled, testid }) {
    const v = Number.isFinite(value) ? value : 0;
    const dec = () => onChange(Math.max(0, v - 1));
    const inc = () => onChange(Math.min(30, v + 1));

    return (
        <div className="flex items-center gap-1.5" data-testid={`${testid}-stepper`}>
            <button
                type="button"
                disabled={disabled}
                onClick={dec}
                data-testid={`${testid}-dec`}
                className="h-9 w-9 rounded-md border border-[var(--border-base)] bg-[var(--bg-base)] text-[var(--text-primary)] hover:border-[var(--accent-border)] hover:text-[var(--accent-hex)] disabled:opacity-30 disabled:hover:border-[var(--border-base)] disabled:hover:text-[var(--text-primary)] transition-colors flex items-center justify-center"
            >
                <Minus className="h-4 w-4" />
            </button>
            <input
                data-testid={`${testid}-input`}
                type="number"
                min={0}
                max={30}
                value={v}
                disabled={disabled}
                onChange={(e) => {
                    const n = parseInt(e.target.value, 10);
                    onChange(Number.isNaN(n) ? 0 : Math.max(0, Math.min(30, n)));
                }}
                className="score-input disabled:opacity-50"
            />
            <button
                type="button"
                disabled={disabled}
                onClick={inc}
                data-testid={`${testid}-inc`}
                className="h-9 w-9 rounded-md border border-[var(--border-base)] bg-[var(--bg-base)] text-[var(--text-primary)] hover:border-[var(--accent-border)] hover:text-[var(--accent-hex)] disabled:opacity-30 disabled:hover:border-[var(--border-base)] disabled:hover:text-[var(--text-primary)] transition-colors flex items-center justify-center"
            >
                <Plus className="h-4 w-4" />
            </button>
        </div>
    );
}
